import c from"@rcf/envs";const o=o=>({[c.QA]:"qa-dc",[c.STAGE]:"stage-dc",[c.PROD]:"domclick"}[o]);export{o as getDomainByEnv};
